import { SubscriberFunctionInterface } from './basic_connection'

export type ServiceClass = {
  subscribe: Function
  unsubscribe: Function
  name: string
}

export enum ServiceNames {
  PublicService = 'PublicService',
  ProxyServiceName = 'ProxyService',
}

export enum RequestTypes {
  Request = 'request',
  Subscribe = 'subscribe',
  Unsubscribe = 'unsubscribe',
}

export enum Events {
  GetRate = 'get_quotes',
  GetTicker = 'ticker',
  GetOrderBook = 'get_orderbook',
  GetTrades = 'get_trades',
  GetUserEvent = 'get_user',
  GetUserWalletEvent = 'get_user_wallet',
  DeleteAccount = 'delete_account',
  UpdateToken = 'update_token',
  SocketStatusConnection = 'socket_status_connection',
  GetUserOrdersEvent = 'get_user_orders',
  EventGetMarketsByFilter = 'get_markets_by_filter',
  EventGetMarkets = 'get_markets',
  GetMarketsByIds = 'get_markets_by_ids',
  GetMarketInfo = 'get_market_info',
  GetWatchlists = 'get_watchlists',
  CreateWatchlist = 'create_watchlist',
  UpdateWatchlist = 'update_watchlist',
  DeleteWatchlist = 'delete_watchlist',
  UpdateWatchlistOrders = 'update_watchlist_orders',
  CreatePriceAlerts = 'create_price_alert',
  UpdatePriceAlerts = 'update_price_alert',
  DeletePriceAlerts = 'delete_price_alert',
  GetUserPriceAlerts = 'get_user_price_alerts',
  UpdateTradingSettingWallet = 'update_trading_setting_wallet'
}

export interface ISubscribeParams {
  [key: string]: any
}

export type IEventParams = {
  [Events.GetRate]: { source_currency: string; target_currency: string; component?: string }
  [Events.GetTicker]: { period: string }
  [Events.GetOrderBook]: { source_currency: string; target_currency: string }
  [Events.GetTrades]: { source_currency: string; target_currency: string }
  [Events.GetMarketInfo]: { source_currency: string; target_currency: string }
  // Добавляй новые event'ы здесь, например:
  // [Events.GetNews]: { filter: string; limit: number };
}

export enum SocketState {
  Ready = 'ready',
  Closed = 'closed',
}

export interface ISubscribeMethodParams {
  params: string[]
  event: string
  callback: SubscriberFunctionInterface
}

export type IAllConnections = {
  [key: string]: IServiceNamesObject
}

export interface IConnections {
  [key: string]: IConnection
}

export interface IServiceNamesObject {
  callbacks: SubscriberFunctionInterface | null
  connections: IConnections
}

export interface ISubscriber {
  id: string
  type: string
  params: ISubscribeParams
  service: ServiceClass
  event: string
  time: number
  key: string
  func: SubscriberFunctionInterface
}

export interface IConnection {
  key: string
  event: string
  params: ISubscribeParams
  service: object
  subscribers: ISubscriber[]
  callback: SubscriberFunctionInterface
}

export interface ISocketStatusConnection {
  data: string
}
